import { useEffect, useRef } from 'react'
import { analytics, type CalculatorType, type CalculatorPayload } from '@/lib/analytics'

export function useCalculatorAnalytics(
  calculatorType: CalculatorType,
  payload: CalculatorPayload | null,
  options: { delayMs?: number; refireOnChange?: boolean } = {}
): void {
  const { delayMs = 1500, refireOnChange = false } = options
  const lastFiredKeyRef = useRef<string | null>(null)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (!payload) return
    const key = JSON.stringify(payload)
    if (!refireOnChange && lastFiredKeyRef.current !== null) return
    if (lastFiredKeyRef.current === key) return

    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      lastFiredKeyRef.current = key
      analytics.calculatorUsed(calculatorType, payload)
    }, delayMs)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [calculatorType, payload, delayMs, refireOnChange])
}
